module.exports = __webpack_public_path__ + "img/047-impatient.ee13846d.png";